import { Award, Star, Upload } from 'lucide-react';

const WAYS = [
  {
    icon: Upload,
    title: 'Upload CNC files',
    body: 'Every qualifying review your upload receives earns you 1 point.',
  },
  {
    icon: Star,
    title: 'Earn via ratings',
    body: 'A combined average of 4.0 stars or higher earns 1 point per qualifying reviewer.',
  },
  {
    icon: Award,
    title: 'Unlock achievements',
    body: 'Achievements marked with a coin pay points once, when you earn them.',
  },
];

export default function HowToEarn() {
  return (
    <ul className="flex flex-col gap-3 rounded-lg bg-neutral-50 p-4">
      {WAYS.map(({ icon: Icon, title, body }) => (
        <li key={title} className="flex gap-3">
          <Icon className="mt-0.5 h-4 w-4 shrink-0 text-green-700" />
          <p className="text-xs leading-relaxed text-muted-foreground">
            <span className="font-semibold text-foreground">{title}.</span>{' '}
            {body}
          </p>
        </li>
      ))}
    </ul>
  );
}
